/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toHospitalProps, toHospitalRequest } from './translator/hospital'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { SelectableHospital, FetchHospital, GetHospital, PostHospital, DeleteHospital } from '@/infrastructure/network/Monitaro/requests/hospital'
import { IHospitalProps } from '@/entities/Hospital'

export default class Hospital extends MonitaroGatewayBase {
  async SelectableHospital(query?: IQueryProps) {
    const response = await this.apiClient.request(new SelectableHospital(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.hospitals.map((prop) => toHospitalProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async FetchHospital(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchHospital(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.hospitals.map((prop) => toHospitalProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async GetHospital(id: string) {
    const { hospital } = await this.apiClient.request(new GetHospital(id))
    return toHospitalProps(hospital)
  }

  async PostHospital(params: IHospitalProps) {
    const { hospital } = await this.apiClient.request(new PostHospital(params.id!, toHospitalRequest(params)))
    return toHospitalProps(hospital)
  }

  async DeleteHospital(id: string) {
    const { hospital } = await this.apiClient.request(new DeleteHospital(id))
    return toHospitalProps(hospital)
  }
}
